import { render, staticRenderFns } from "./CreateTicketDialog.vue?vue&type=template&id=2ef0c879&scoped=true&"
import script from "./CreateTicketDialog.vue?vue&type=script&lang=js&"
export * from "./CreateTicketDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateTicketDialog.vue?vue&type=style&index=0&id=2ef0c879&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef0c879",
  null
  
)

export default component.exports